@if (items.length) {
  <div class="p-6 md:p-8 font-sans">
    <h1 class="text-[32px] font-semibold text-gray mb-6">
      {{ 'FavoritePage.Items' | translate }} ({{ items.length }})
    </h1>

    @if (!isLoading && items.length === 0) {
      <div class="text-center py-20">
        {{ 'FavoritePage.Empty' | translate }}
      </div>
    }

    @for (item of items; track item.id) {
      <div
        class="bg-[#ffffff] border border-[#E6E6E6] border-t-0 rounded-lg shadow-[0px_2px_4px_-2px_#1018280F,0px_4px_8px_-2px_#1018281A] mb-6 p-5"
      >
        <div
          class="flex justify-between items-center border-b border-[#DADADA] pb-3 mb-5"
        >
          <div class="flex items-center gap-2">
            <img
              [src]="item.storeLogoUrl"
              alt="Store Logo"
              class="w-6 h-6 rounded-full object-cover"
            />
            <span class="text-base font-medium text-blue-dark-a">{{
              item.storeName
            }}</span>
          </div>
          <a
            [routerLink]="['/seller', item.sellerId]"
            class="text-base cursor-pointer text-blue-dark-a font-medium underline underline-offset-2 hover:text-blue-800 transition-colors"
          >
            {{ 'FavoritePage.ViewStore' | translate }}
          </a>
        </div>

        <div class="flex flex-col md:flex-row gap-6">
          <div class="relative w-full md:w-56 shrink-0">
            <a
              [routerLink]="['/product', item.productSlug]"
              class="block cursor-pointer"
              [attr.aria-label]="item.title"
            >
              <img
                [src]="item.imageUrl"
                [alt]="item.title"
                class="w-full h-48 object-cover rounded-md bg-gray-100"
              />
            </a>
            <div
              (click)="removeFromWishlist(item.id)"
              class="absolute top-2 left-2 bg-[#ffffff] rounded-full p-1.5 shadow-sm cursor-pointer hover:bg-gray-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 text-[#2a9cbd]"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                />
              </svg>
            </div>
          </div>

          <div class="grow flex flex-col justify-between py-1">
            <div>
              <h2 class="text-[#384250] text-[22px] font-semibold leading-tight mb-2">
                <a
                  [routerLink]="['/product', item.productSlug]"
                  class="cursor-pointer hover:text-[#2187AB] transition-colors"
                >
                  {{ item.title }}
                </a>
              </h2>

              <div class="flex items-center gap-1 mb-3">
                <div class="flex text-[#EFB100]">
                  @for (star of getStars(item.rating); track $index) {
                    <svg
                      class="w-4 h-4"
                      [ngClass]="{ 'text-gray-300': $index >= item.rating }"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                      />
                    </svg>
                  }
                </div>
                <span class="text-[#384250] ml-1"
                  >Reviews({{ item.reviewsCount }})</span
                >
              </div>

              <p class="text-sm text-[#384250] mb-2 font-medium">
                {{ 'FavoritePage.Delivery' | translate }}: {{ item.deliveryDate }}
                {{ 'FavoritePage.Days' | translate }}
              </p>

              @if (item.hasDiscountOnCart) {
                <div
                  class="flex items-center gap-1.5 text-[#C6624E] text-lg font-medium mb-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    />
                  </svg>
                  {{ 'FavoritePage.DiscountOnCart' | translate }}
                </div>
              }
            </div>

            <div class="flex items-baseline gap-3 mt-auto">
              <span class="text-[26px] font-bold text-[#2187AB]"
                >SYP {{ item.currentPrice }}
              </span>
              @if (item.oldPrice) {
                <span class="text-[26px] text-[#6D6D6D] line-through"
                  >SYP {{ item.oldPrice }}</span
                >
              }
            </div>
          </div>

          <div class="flex flex-col gap-3 justify-center md:w-48 shrink-0">
            <button
              (click)="addToCart(item)"
              [disabled]="getRemainingStock(item) <= 0"
              class="w-full py-2 px-4 rounded-lg text-lg font-medium transition-all duration-200"
              [class.bg-[#2596BE]]="getRemainingStock(item) > 0"
              [class.text-white]="getRemainingStock(item) > 0"
              [class.hover:bg-[#2385a1]]="getRemainingStock(item) > 0"
              [class.bg-gray-300]="getRemainingStock(item) <= 0"
              [class.text-gray-500]="getRemainingStock(item) <= 0"
              [class.opacity-50]="getRemainingStock(item) <= 0"
              [class.cursor-not-allowed]="getRemainingStock(item) <= 0"
            >
              {{ 'Add to Cart' | translate }}
            </button>
            <!-- @if (item.secondaryActionType === 'dropdown') {
  <div class="relative">

    <button
      (click)="toggleDropdown(item.id)"
      class="w-full border border-[#2a9cbd] text-[#2a9cbd] hover:bg-[#eaf5f8] py-2 px-4 rounded-md flex justify-between items-center text-sm font-semibold transition-colors">

      <span class="flex-grow text-center">
        {{ item.secondaryActionText }}
      </span>

      <svg xmlns="http://www.w3.org/2000/svg"
           class="w-4 h-4 text-[#2a9cbd]"
           fill="none"
           viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    @if (openedDropdownId === item.id) {
      <div class="absolute top-full left-0 right-0 mt-1 bg-white border rounded-md shadow-lg z-10">

        @for (optionName of item.optionNames ?? []; track $index) {
          <div class="px-4 py-2 border-b last:border-b-0">
            {{ optionName }}
          </div>
        }

      </div>
    }

  </div>
} -->
            <!-- @else if (item.secondaryActionType === 'button') {
            <button class="w-full border border-[#2596BE] text-[#2596BE] hover:bg-[#eaf5f8] py-2 px-4 rounded-lg text-sm font-semibold transition-colors text-center">
              {{ item.secondaryActionText }}
            </button>
          } -->
            <!-- @else if (item.secondaryActionType === 'disabled-dropdown') {
          <button class="w-full opacity-40 border border-[#2596BE] text-[#2187AB] py-2 px-4 rounded-md flex justify-between items-center text-sm font-semibold cursor-not-allowed">
  <span class="flex-grow text-center">{{ item.secondaryActionText }}</span>
  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
  </svg>
</button>
          } -->
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <app-empty-page
    [imageSrc]="'/assets/images/favourites-empty-state-bg.svg'"
    [message]="'No favourites yet'"
    [buttonText]="'Start shopping'"
    [buttonLink]="'/home'"
  />
}
